import Vue from 'vue';

const state = {
	hrDocumentTemplates: [],
	hrDocumentTemplates_loading: false
};

const getters = {
	hrDocumentTemplates: state => {
		return state.hrDocumentTemplates;
	},
	hrPolicyTemplates: state => {
		return state.hrDocumentTemplates.filter(x => x.type === 0);
	},
	getHrDocumentTemplate: state => id => {
        return state.hrDocumentTemplates.find(x => x.id === id)
    }
};

const actions = {
	getHrDocumentTemplates({ commit }) {
		console.log('Retrieving HR Document Templates...');
		commit('GET_DOC_TEMPLATES_PENDING');
		return Vue.axios
			.get(`/api/marketplace/hrDocumentTemplates`)
			.then(response => {
				commit('GET_DOC_TEMPLATES_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_DOC_TEMPLATES_FAILURE', error);
			});
	},
	getHrDocumentTemplateFile({ commit }, templateId) {
		console.log('Retrieving HR Document Templates File');
		return Vue.axios({
			url: `/api/marketplace/HRDocumentTemplates/${templateId}/File`,
			method: 'GET',
			responseType: 'blob'
		});
	}
};

const mutations = {
	GET_DOC_TEMPLATES_PENDING(state) {
		state.hrDocumentTemplates_loading = true;
	},
	GET_DOC_TEMPLATES_SUCCESS(state, data) {
		state.hrDocumentTemplates_loading = false;
		state.hrDocumentTemplates = data;
	},
	GET_DOC_TEMPLATES_FAILURE(state, error) {
		state.hrDocumentTemplates_loading = false;
		console.log(error);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
